import { moduleProviderFactory } from "core/providers";
import { NikoOngoingMissingInventoryEmailEdit } from "application/niko-ongoing-missing-inventory/pages";

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: "master.app.main.facility-order",
				pattern: "/facility-orders",
                children: [
                    {
                        name: "master.app.main.facility-order.niko-ongoing-missing-inventory.edit-email",
                        pattern: "/:facilityOrderId/niko-ongoing-missing-inventory",
                        component: NikoOngoingMissingInventoryEmailEdit,
                        data: {
                            crumbs: [
                                {
                                    title: "FACILITY_ORDER.CRUMB.TEMPLATES",
                                    route: 'master.app.main.facility-order.facility-order-template.list'
                                },
                                {
                                    title: "Ongoing Missing Inventory",
                                    route: 'master.app.main.facility-order.niko-ongoing-missing-inventory.edit-email'
                                }
                            ]
                        }
                    },                 
                ]
            }
        ],
        menu: [
            {
				title: "MENU.FACILITY_ORDERS",
				icon: "package",
				authorization: "coreUserSection.read",
				order: 5,
				subMenu: [
					{
						title: "MENU.NIKO_FACILITY_ORDERS",
						authorization: "facilityOrderSection.read",
						route: "master.app.main.niko-facility-order.list",
						order: 3,
					}  
				]
			},
        ]
    });
})();
